import React, { useContext, useEffect } from "react";
import TitleBar from "../../components/layout-components/TitleBar";
import AppContext from "../../config/AppContext";
import "./ChangeLogs.scss";
import { sidebarContext } from "../../util/context";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ChangeLogs = () => {
  const { mode } = useContext(AppContext);
  const { userPreferences } = useContext(sidebarContext);
  const { t } = useTranslation();

  const applicationVersion = userPreferences?.applicationVersion;

  useEffect(() => {
    console.log("application log version:", applicationVersion);
  }, [applicationVersion]);

  const updates = [
    {
      date: `${t("RAL1253")} 08, 2025`,
      version: '1.6.0',
      sections: [
        {
          title: t("RAL1052"),
          items: [
            {
              text: t("RAL1243"),
              subItems: [
                t("RAL1244"),
                t("RAL1245"),
                t("RAL1246"),
              ],
            },
            {
              text: t("RAL1247"),
              subItems: [
                t("RAL1248"),
                t("RAL1249"),
              ],
            },
            {
              text: t("RAL1250"),
              subItems: [
                t("RAL1251"),
                t("RAL1252"),
              ],
            },
          ],
        },
      ],
    },
    {
      date: `${t("RAL1193")} 14, 2025`,
      version: '1.5.0',
      sections: [
        {
          title: t("RAL1052"),
          items: [
            t("RAL1198"),
            t("RAL1199"),
            t("RAL1200"),
            t("RAL1201"),
            t("RAL1202"),
          ],
        },
      ],
    },
    {
      date: `${t("RAL1193")} 01, 2025`,
      version: '1.4.0',
      sections: [
        {
          title: t("RAL1052"),
          items: [
            t("RAL1194"),
            t("RAL1195"),
          ],
        },
      ],
    },
    {
      date: `${t("RAL1141")} 26, 2025`,
      version: '1.3.0',
      sections: [
        {
          title: t("RAL1052"),
          items: [
            t("RAL1183"),
            {
              text: t("RAL1184"),
              subItems: [
                t("RAL1185"),
                t("RAL1186"),
              ],
            },
            t("RAL1187"),
          ],
        },
      ],
    },
    {
      date: `${t("RAL1141")} 17, 2025`,
      version: '1.2.0',
      sections: [
        {
          title: t("RAL1052"),
          items: [
            t("RAL1142"),
            t("RAL1143"),
            t("RAL1144"),
            t("RAL1145"),
            t("RAL1146"),
          ],
        },
      ],
    },
    {
      date: `${t("RAL1099")} 15, 2025`,
      version: '1.1.0',
      sections: [
        {
          title: t("RAL1052"),
          items: [
            t("RAL1101"),
            t("RAL1102"),
            t("RAL1103"),
          ],
        },
      ],
    },
    {
      date: `${t("RAL1051")} 16, 2025`,
      version: '1.0.0',
      sections: [
        {
          title: t("RAL1052"),
          items: [
            t("RAL1053"),
            t("RAL1054"),
            t("RAL1055"),
            t("RAL1056"),
            t("RAL1057"),
            t("RAL1058"),
            t("RAL1059"),
            t("RAL1060"),
            t("RAL1061"),
            t("RAL1062"),
            t("RAL1063"),
            t("RAL1064"),
            t("RAL1065"),
            t("RAL1066"),
          ],
        },
      ],
    },
  ];

  return (
    <div>
      <TitleBar id="header-text-add-project" title={t("RAL1048")} />
      <div className="update-content">
        {updates.map((update, updateIndex) => (
          <div key={updateIndex} className="update-meta">
            <div
              className={
                mode === "dark" ? "update-meta1Dark" : "update-meta1"
              }
            >
              <span
                className={
                  mode === "dark" ? "update-datesDark" : "update-dates"
                }
              >
                {update.date}
              </span>
              <span
                className={
                  mode === "dark" ? "update-versionsDark" : "update-versions"
                }
              >
                {t("RAL1050")} {update.version}
              </span>
            </div>
            <div
              className={
                mode === "dark" ? "update-sectionDark" : "update-section"
              }
            >
              {update.sections.map((section, sectionIndex) => (
                <div key={sectionIndex}>
                  <span
                    className={
                      mode === "dark" ? "update-titleDark" : "update-title"
                    }
                  >
                    {section.title}
                  </span>
                  <ul
                    className={
                      mode === "dark" ? "update-ulDark" : "update-ul"
                    }
                  >
                    {section.items.map((item, itemIndex) => (
                      typeof item === "string" ? (
                        <li key={itemIndex}>{item}</li>
                      ) : (
                        <li key={itemIndex}>
                          {item.text}
                          {item.subItems && item.subItems.length > 0 && (
                            <ul className={mode === "dark" ? "update-sub-ulDark" : "update-sub-ul"}>
                              {item.subItems.map((subItem, subIndex) => (
                                <li key={subIndex}>{subItem}</li>
                              ))}
                            </ul>
                          )}
                        </li>
                      )
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChangeLogs;
